import { useDefaultAttachmentsApiForControllerRoute } from "."

export function usePlanLayoutAttachmentApi() {
  const defaultAPI = useDefaultAttachmentsApiForControllerRoute("planLayout")

  return {
    ...defaultAPI,
  }
}
